import { useZero } from "@rocicorp/zero/react";
import { nanoid } from "nanoid";
import { sharedMutators } from "../../shared/mutators";
import { useDefaultSkillGrants } from "./useDefaultSkillGrants";
import { useHasAccess } from "./useHasAccess";

export const newSkillDefaults = {
  name: "untitled-skill",
  description: "Describe when the AI should use this skill.",
  instructions: "",
};

export function useCreateSkill(spaceId?: string) {
  const z = useZero();
  const canCreate = useHasAccess("tenant:skill_create");
  const grants = useDefaultSkillGrants(spaceId);

  const createSkill = (): string | null => {
    if (!canCreate) return null;
    const newId = nanoid(12);
    z.mutate(
      sharedMutators.createSkill({
        skillId: newId,
        ...newSkillDefaults,
        enabled: true,
        grants,
      })
    );
    return newId;
  };

  return { canCreate, createSkill };
}
